import {ShelfUnitSpec} from './shelf/spec';

export interface ShelfPreview {
  spec: ShelfUnitSpec;
};

export const DEFAULT_SHELF_PREVIEW: ShelfPreview = {
  spec: null
};



// WEBPACK FOOTER //
// ./src/models/shelf-preview.ts